import { SplitPageLayout } from "shared/components";

export const VerifyCode = () => {
  return (
    <SplitPageLayout
      title='Email Verification Sent'
      subtitle='Email verification is now handled by Auth0. Please follow the instructions in the email sent by Auth0 to complete verification.'
    />
  );
};
